import React from "react";
import { FolderGit2 } from "lucide-react";
import SharedHeroSection from "./SharedHeroSection";

export default function PortfolioHeroSection() {
    return (
        <SharedHeroSection
            badge="50+ Projects Delivered"
            badgeIcon={FolderGit2}
            title={(
                <>
                    <span className="bg-gradient-to-r from-blue-400 via-indigo-400 to-purple-400 bg-clip-text text-transparent">Every Project</span><br /> Tells a Story of Innovation
                </>
            )}
            description="Versatile across technology, we have delivered 115+ products across the globe that earned us the dignity and trustworthiness we embrace."
        />
    );
}
